// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ao-4";
export var collapsed = "_ao-1";
export var headerBar = "_ao-0";
export var leftHeaderContent = "_ao-3";
export var subjectContainer = "_ao-2";